import { useEffect, useState } from "react";
import { Typography, Table } from "antd";

import { ErrorResponse } from "utils/types";
import notifier from "utils/notifier";

import './index.scss';

const { Title } = Typography;

interface EmailListingsPageProps {
  getContacts(): any,
  isFetchingContacts: boolean,
}

const EmailListings = (props: EmailListingsPageProps) => {

  const [listings, setListings] = useState<any[]>([]);

  const columns = [
    {
      title: 'Department',
      dataIndex: 'RmiDepartment',
      key: 'RmiDepartment',
    },
    {
      title: 'Email',
      dataIndex: 'RmiEmail',
      key: 'RmiEmail',
      render: (text: string) => <a href={`mailto:${text}`}>{text}</a>
    },
    {
      title: 'Extension',
      dataIndex: 'RmiPhone',
      key: 'RmiPhone',
    },
  ];

  useEffect(() => {
    props.getContacts()
    .then((response: any[]) => {
      setListings(response);
    })
    .catch((err: ErrorResponse) => {
      notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
    });
  }, []);

  return (
    <div className="flex-lg-wrap justify-content-start">
      <Title level={5}>Department Contacts</Title>
      <Table 
        dataSource={listings} 
        columns={columns} 
        pagination={false}
        rowKey={'RmiDepartment'}
        loading={props.isFetchingContacts}
      />
    </div>
  );
};

export default EmailListings;